
<template>
    <div class="px-3">

        <v-card color="" elevation="0">
            <v-divider></v-divider>

            <div class="d-flex justify-space-between mt-6">
                <v-text-field style="max-width: 400px" v-model="search" append-icon="mdi-magnify" outlined
                    :label="$t('products.ASUS.search')" single-line dense hide-details></v-text-field>
            </div>
            <v-card outlined>
                <v-data-table :headers="headers" :items="documents" :loading="loading" :search="search">
                    <template v-slot:[`item.createdOn`]="{ item }">
                        {{ item.createdOn | dateTime }}
                    </template>


                    <template v-slot:[`item.status`]="{ item }">
                        <v-chip label small class="mx-2" v-if="item.status == 1" color="error">{{
                            $t("reports.support.status.pending")
                        }}</v-chip>
                        <v-chip label small class="mx-2" v-if="item.status == 2" color="warning">{{
                            $t("reports.support.status.processing")
                        }}</v-chip>
                        <v-chip label small class="mx-2" v-if="item.status == 3" color="success">{{
                            $t("reports.support.status.done")
                        }}</v-chip>
                    </template>

                    <template v-slot:[`item.reason`]="{ item }">
                        <v-btn icon @click="open(item)"><v-icon small>mdi-pencil</v-icon></v-btn>
                    </template>
                </v-data-table>
            </v-card>
            <v-dialog v-model="modal.show" max-width="768">
                <v-card class="mx-auto">
                    <v-card-title v-if="modal.snap">
                        <v-icon small>mdi-pound</v-icon> {{ modal.snap.id }}
                        <div class="pt-2"></div>
                        <v-chip label small class="mx-2" v-if="modal.snap.status == 1" color="error">{{
                            $t("reports.support.status.pending")
                        }}</v-chip>
                        <v-chip label small class="mx-2" color="warning" v-if="modal.snap.status == 2">{{
                            $t("reports.support.status.processing")
                        }}</v-chip>
                        <v-chip label small class="mx-2" color="success" v-if="modal.snap.status == 3">{{
                            $t("reports.support.status.done")
                        }}</v-chip>
                        <v-spacer></v-spacer>

                        <v-btn @click="close()" icon class="ml-2"><v-icon>mdi-close</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text v-if="modal.snap">
                        <!-- <v-card outlined class="mb-2">
                            <div class="d-flex">
                                <div style="flex: 1 1 50%" class="pa-2">
                                    <p><strong>{{ $t('reports.support.data.name') }}:</strong> {{ modal.snap.name }}</p>
                                    <p><strong>{{ $t('reports.support.data.phoneNumber') }}:</strong> {{
                                        modal.snap.phoneNumber
                                    }}</p>
                                    <p><strong>{{ modal.snap.type }}:</strong> {{ modal.snap.personalDocument }}</p>
                                    <p><strong>{{ $t('reports.support.data.company') }}:</strong> {{ modal.snap.company }}
                                    </p>
                                    <p><strong>{{ $t('reports.support.data.document') }}:</strong> {{ modal.snap.document }}
                                    </p>
                                </div>
                                <v-divider vertical></v-divider>
                                <div style="flex: 1 1 50%" class="pa-2">
                                    <p><strong>{{ $t('reports.support.data.addressAlias') }}:</strong> <span
                                            v-html="modal.snap.address.alias ? modal.snap.address.alias : '<em>NC</em>'"></span>
                                    </p>
                                    <p><strong>{{ $t('reports.support.data.addressStreet') }}:</strong> {{
                                        modal.snap.address.street }}, {{ modal.snap.address.number }} {{
        modal.snap.address.complement }}</p>
                                    <p><strong>{{ $t('reports.support.data.addressCity') }}:</strong> {{
                                        modal.snap.address.district }} / {{ modal.snap.address.city }}</p>
                                    <p><strong>{{ $t('reports.support.data.addressZipCode') }}:</strong> <span
                                            v-html="modal.snap.address.zipCode ? modal.snap.address.zipCode : '<em>NC</em>'"></span>
                                    </p>
                                </div>
                            </div>
                        </v-card> -->
                        
    
                        <fieldset style="border-color: 1px solid #a3a3a3; margin-bottom: 15px">
                            <legend>Identificación del cliente</legend>
                            <div style="padding: 10px; font-size: 14px; padding-bottom: 4px;"><strong v-html="modal.snap.type"></strong>: {{ modal.snap.personalDocument}}</div>
                            <div style="padding: 10px; font-size: 14px; padding-bottom: 4px;"><strong>Nombre completo</strong>: {{ modal.snap.personamenalDocument}}</div>
                            <div style="padding: 10px; font-size: 14px; padding-bottom: 4px;"><strong>Empresa</strong>: {{ modal.snap.company}}</div>
                            <div style="padding: 10px; font-size: 14px; padding-bottom: 4px;"><strong>RUC</strong>: {{ modal.snap.document}}</div>
                            <div style="padding: 10px; font-size: 14px; padding-bottom: 4px;"><strong>Teléfono</strong>: {{ modal.snap.phoneNumber}}</div>
                            <div style="padding: 10px; font-size: 14px; padding-bottom: 4px;"><strong>Correo electrónico</strong>: {{ modal.snap.email}}</div>
                        </fieldset>
    
                        <fieldset style="border-color: 1px solid #a3a3a3; margin-bottom: 15px">
                            <legend>Direccion</legend>
                            <div style="padding: 10px; font-size: 14px; padding-bottom: 4px;"><strong>Calle</strong>: {{ modal.snap.address.street}} {{ modal.snap.address.number}} {{modal.snap.address.complement }}</div>
                            <div style="padding: 10px; font-size: 14px; padding-bottom: 4px;"><strong>{{ $t('accountSettings.address.district') }}</strong>: {{ modal.snap.address.district}}</div>
                            <div style="padding: 10px; font-size: 14px; padding-bottom: 4px;"><strong>{{ $t('accountSettings.address.city') }}</strong>: {{ modal.snap.address.city}}</div>
                            <div style="padding: 10px; font-size: 14px; padding-bottom: 4px;"><strong>{{ $t('accountSettings.address.state') }}</strong>: {{ modal.snap.address.state}}</div>
                        </fieldset>
    
                        <fieldset style="border-color: 1px solid #a3a3a3; margin-bottom: 15px">
                            <legend>Detalle de la Reclamación</legend>
                            <div style="padding: 10px; font-size: 14px; padding-bottom: 4px;"><strong>Identificación del registro</strong>: {{ modal.snap.senderId}}</div>
                            <div style="padding: 10px; font-size: 14px; padding-bottom: 4px;"><strong>Fecha de envío</strong>: {{ modal.snap.sentDate | dateTime}} </div>
                            <div style="padding: 10px; font-size: 14px; padding-bottom: 4px;"><strong>{{ modal.snap.reason }}</strong>: {{modal.snap.description}}</div>
                        </fieldset>

                        <!-- <v-card outlined class="mb-2 pa-2">
                            <p><strong>{{ modal.snap.reason }}</strong></p>
                            <p v-html="modal.snap.description"></p>
                        </v-card> -->
                        <v-card outlined class="mb-2 pa-2 d-flex">
                            <div style="width: 350px">
                                <h4>Registros del caso</h4>
                                <p style="line-height: 36px" v-for="(log,i) in modal.snap.log" :key="i"><strong
                                        class=" pr-1">{{ $t(`reports.status.${log.action}`) }}: </strong> <span
                                        class="">{{ log.date | dateTimeS
                                        }}</span>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn class="ml-2" x-small icon v-bind="attrs"
                                                v-on="on"><v-icon small>mdi-account</v-icon></v-btn>
                                             
                                            </template>
                                            <span>{{ log.user.name }} ({{ log.user.email }})</span>
                                          </v-tooltip>
                                          
                                </p>
                                <!-- <p style="line-height: 36px" v-if="modal.snap.readyOn"><strong
                                        style="flex: 0 0 50%" class="text-right pr-1">{{ $t('reports.support.data.readOn')
                                        }}:
                                    </strong><span class="" style="flex: 0 0 50%">{{ modal.snap.readyOn | dateTimeS
                                    }}
                                   

                                    </span></p> -->
                                <!-- <div v-else>
                                    <v-btn elevation="0" block class="mb-2" color="primary" @click="log('readyOn')">{{
                                        $t('reports.support.registerRead') }}</v-btn>
                                </div> -->
                                <!-- <p style="line-height: 36px" class="" v-if="modal.snap.replyedOn"><strong>{{
                                    $t('reports.support.data.repliedOn') }}</strong> <span class=""
                                        style="flex: 0 0 50%">{{ modal.snap.replyedOn | dateTimeS }} -->
                                        <!-- <v-btn icon small><v-icon
                                                        small>mdi-pencil</v-icon></v-btn> -->
                                    <!-- </span></p>
                               
                                <p style="line-height: 36px" class="" v-if="modal.snap.solvedOn"><strong>{{
                                    $t('reports.support.data.solvedOn') }}</strong> <span class=""
                                        style="flex: 0 0 50%">{{ modal.snap.solvedOn | dateTimeS }} -->
                                        <!-- <v-btn icon small><v-icon
                                                            small>mdi-pencil</v-icon></v-btn> -->
                                    <!-- </span></p> -->
                               
                            </div>
                            <div class="d-flex flex-column justify-space-between" style="height: 340px">
                                <div v-if="!modal.snap.replyedOn">
                                    <label><strong>
                                        Cargar archivo con mensaje al cliente
                                    </strong>
                                    </label>
                                    <p>(correo electrónico o copia de la carta impresa)</p>
                                    <FileUpload :unique="true" :sample="true" :snap="modal.snap.file" :target="`help-center/case/${modal.snap.id}`" :error="null"
            @set-upload="log('replyedOn', $event)"></FileUpload>

                                    <!-- <v-btn elevation="0" block class="mb-2" :disabled="!modal.snap.readyOn || !modal.snap.file.length" color="primary"
                                        @click="log('replyedOn')">{{ $t('reports.support.registerReply') }}</v-btn> -->
                                </div>
                                <div v-else class="d-flex flex-end">
                                    <v-spacer></v-spacer>
                                    <v-btn :href="modal.snap.file" target="_blank" outlined><v-icon class="mr-2">mdi-download</v-icon> Descargar el archivo de respuesta</v-btn>
                                </div>
                                <div v-if="!modal.snap.solvedOn">
                                    
                                    <!-- <p>Fecha de finalización del caso y persona responsable
                                    </p> -->
                                    <v-btn elevation="0" block class="mb-2" :disabled="!modal.snap.replyedOn"
                                        color="primary" @click="log('solvedOn')">
                                        Finalizar caso
                                        <!-- {{ $t('reports.support.registerConclusion')}} -->
                                    </v-btn>
                                </div>
                            </div>
                            </v-card>
                            <div>
                            <v-spacer></v-spacer>
                            <div class="d-flex align-end" style="flex: 0 0 200px">
                                <v-spacer vertical></v-spacer>
                                <div class="d-flex">
                                    <v-spacer></v-spacer>
                                    <v-btn text class="mr-1" @click="close()">{{ $t('common.cancel') }}</v-btn>
                                    <v-btn color="success" elevation="0" @click="save()" :disabled="!modal.changes"
                                        :loading="processing">{{ $t('common.save') }}</v-btn>
                                </div>
                            </div>
                            </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card>
    </div>
</template>
<script>
import config from "@/store/config";
import moment from "moment";
import { mapActions } from "vuex";
import FileUpload from '@/interface/FileUpload.vue'
// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { initializeApp } from "firebase/app"

import {
    getFirestore,
    collection,
    query,
    setDoc,
    getDocs,
    doc,
    DocumentSnapshot,
} from "firebase/firestore";
export default {
    name: "AsusList",
    components: {
        FileUpload
    },
    data() {
        return {

            processing: false,
            loading: true,
            search: this.$route.query.q ? this.$route.query.q : "",
            documents: [],
            modal: {
                show: false,
                snap: null,
                changes: false
            },
            time: [null, null, null, null],
            date: [null, null, null, null],
            menu: [false, false, false, false]
        };
    },
    watch: {
        'modal.show': {
            handler(v) {
                if (!v) {
                    this.modal.snap = null
                    this.modal.changes = false
                }
                else{
                    if(!this.modal.snap.hasOwnProperty('file')){
                        this.modal.snap.file = []
                    }
                    if(!this.modal.snap.hasOwnProperty('log')){
                        this.modal.snap.log = []
                    }
                    if(!this.modal.snap.readyOn){
                        this.modal.snap.readyOn = moment().format()
                        this.save(false)
                    }
                    if(!this.modal.snap.replyedOn)
                    this.modal.snap.log.push({
                        action: "read", 
                        date: moment().format(),
                        user: {
                            name: this.$root.auth.user.name,
                            id: this.$root.auth.user.uid,
                            email: this.$root.auth.user.email,
                        }
                    })
                }
            }
        }
    },

    computed: {
        headers() {
            return [
                {
                    text: this.$t("reports.support.data.id"),
                    align: "start",
                    sortable: true,
                    value: "id",
                },
                {
                    text: this.$t("reports.support.data.customer"),
                    value: "company",
                },
                {
                    text: this.$t("reports.support.data.document"),
                    value: "document",
                },
                {
                    text: this.$t("reports.support.data.email"),
                    value: "email",
                },

                {
                    text: this.$t("reports.support.data.status"),
                    align: "center",
                    sortable: true,
                    value: "status",
                },

                {
                    text: this.$t("reports.support.data.createdOn"),
                    align: "start",
                    sortable: true,
                    value: "createdOn",
                },
                {
                    text: "",
                    value: "reason",
                    align: "end",
                    sortable: false
                }
                //   {
                //     text: '',
                //     align: "end",
                //     sortable: false,
                //     value: "preview"
                //   }
            ];
        },

        //   selection() {
        //     if (this.type == "selectToPackage") {
        //       const list = this.documents.filter((asu) => {
        //         asu.duration = this.calcTotalDaysPeriod(asu);
        //         return asu.selected;
        //       });
        //       return list;
        //     }
        //     return [];
        //   },
    },
    // created() {
    //   if (this.type == "selectToPackage") {
    //     this.headers.unshift({ text: "", value: "selected" });
    //   } else {
    //     this.headers.splice(this.headers.length - 2, 1);
    //   }
    // },
    mounted() {
        this.loadDocuments();
    },

    methods: {
        ...mapActions("snackbar", ["showSnack"]),
        save(quiet = true) {
            if(quiet)
            this.processing = true
            const firebase = initializeApp(config)
            const db = getFirestore(firebase)
            if (this.modal.snap.solvedOn) {
                this.modal.snap.status = 3
            }
            else {
                if (this.modal.snap.readyOn) {
                    this.modal.snap.status = 2
                }
            }

            setDoc(doc(db, "problemsAndSolves", this.modal.snap.id), this.modal.snap).then(() => {
                if(quiet){
                    this.modal.show = false
                    this.modal.snap = null
    
                    this.processing = false
                    this.loadDocuments()
                    this.showSnack({
                        text: this.$t("reports.support.saved"),
                        color: "success",
                        timeout: 3800,
                        icon: "mdi-check",
                    });
                }
            })
        },
        close() {
            this.modal.snap = null
            this.modal.show = false
        },
        open(item) {
            this.modal.snap = item
            this.modal.show = true
        },
        log(field, e = null) {
            this.modal.changes = true
            this.modal.snap[field] = moment().format()
            if(e)
            this.modal.snap.file = e
            if(!this.modal.snap.hasOwnProperty('log')){
                    this.modal.snap.log = []
                    this.modal.snap.readyOn = moment().format()
            }
                this.modal.snap.log.push({
                    action: field, 
                    date: moment().format(),
                    user: {
                        name: this.$root.auth.user.name,
                        id: this.$root.auth.user.uid,
                        email: this.$root.auth.user.email,
                    }
                })
            
        },
        loadDocuments() {
            this.loading = true;
            const firebase = initializeApp(config);
            const db = getFirestore(firebase);
            const q = query(collection(db, "problemsAndSolves"));
            const querySnapshot = getDocs(q);
            const documents = [];
            querySnapshot.then((docs) => {
                docs.forEach((document) => {
                    documents.unshift(document.data())
                });
                this.documents = documents
                this.loading = false
            });
        },
    },
};
</script>
  
<style lang="scss" scoped></style>
  